export enum GetLocationTypes {
  SEARCH_LOCATIONS_CONFIG = '[LOCATIONS] Search LOCATIONS',
  SEARCH_LOCATIONS_CONFIG_SUCCESS = '[LOCATIONS] Search LOCATIONS Success',
  SEARCH_LOCATIONS_CONFIG_ERROR = '[LOCATIONS] Search LOCATIONS Error',
}

type GetLocationsConfiguration = {
  type: typeof GetLocationTypes.SEARCH_LOCATIONS_CONFIG;
};
type GetLocationsConfigurationSuccess = {
  type: typeof GetLocationTypes.SEARCH_LOCATIONS_CONFIG_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any[] };
};
type GetLocationsConfigurationError = {
  type: typeof GetLocationTypes.SEARCH_LOCATIONS_CONFIG_ERROR;
  payload: { error: string };
};

export type LocationActionTypes =
  | GetLocationsConfiguration
  | GetLocationsConfigurationSuccess
  | GetLocationsConfigurationError;

export const locationActionsTypes = {
  getLocationInfo: (): GetLocationsConfiguration => ({
    type: GetLocationTypes.SEARCH_LOCATIONS_CONFIG,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLocationInfoSuccess: (data: any[]): GetLocationsConfigurationSuccess => ({
    type: GetLocationTypes.SEARCH_LOCATIONS_CONFIG_SUCCESS,
    payload: { data },
  }),
  getLocationInfoError: (error: string): GetLocationsConfigurationError => ({
    type: GetLocationTypes.SEARCH_LOCATIONS_CONFIG_ERROR,
    payload: { error },
  }),
};
